export default __webpack_public_path__ + "static/media/canvasAndFramedA2Wood.ccfa8227.jpg";